import React, { useEffect } from 'react'
import Breadcrum from '../../components/common/Breadcrum';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { callDetailByPhone } from '../../redux/slices/callCollectionSlice';
import moment from 'moment';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function EmployeeCallAnalysis({ id }) {
     const dispatch = useDispatch();
  const { data = [], loading: loading } = useSelector(
    (state) => state?.callCollections || {}
  );
  useEffect(() => {
    if(id){
        console.log(id)
        dispatch(callDetailByPhone({ id: id }));
    }
  }, [dispatch, id]);

  const dataChart = {
  labels: [
    'Total Calls',
    
    'Missed Calls',
    'Incoming Calls',
    'Outgoing Calls',
  ],
  datasets: [
    {
      label: 'My',
      data: [data.myCalls,  data.myMissedCalls, data.myIncomingCalls, data.myOutgoingCalls], // my values (converted duration to minutes)
      backgroundColor: 'rgba(54, 162, 235, 0.6)',
    },
    {
      label: 'Total',
      data: [data.totalCalls,  data.totalMissedCalls, data.totalIncomingCalls, data.totalOutgoingCalls], // total values (converted duration to minutes)
      backgroundColor: 'rgba(255, 99, 132, 0.6)',
    },
  ],
};

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top' ,
    },
    title: {
      display: true,
      text: 'Call Statistics',
    },
  },
};

  return (
    <>
      <div>
      

      </div>
      <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow my-5">
        <h2 className="text-lg font-semibold mb-2"></h2>
         <div className='mb-5'>
             <b className='text-lg'>Name : </b> <span>{data.name}</span> &nbsp;&nbsp;&nbsp;&nbsp;
        <b className='text-lg'>Phone : </b> <span>{data.phone}</span>
         </div>
        <div className="grid">
          <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-gray-100 dark:bg-gray-700 p-4 rounded-lg shadow">
              <h3 className="font-semibold">Total Calls</h3>
              <p className="text-2xl">{data.myCalls}/{data.totalCalls}</p>
            </div>
            <div className="bg-gray-100 dark:bg-gray-700 p-4 rounded-lg shadow">
              <h3 className="font-semibold">Total Duration</h3>
              <p className="text-lg">{moment.duration(data.myCallDuration,'seconds').humanize()}&nbsp;<b>/</b>&nbsp;{moment.duration(data.totalCallDuration,'seconds').humanize()}</p>
            </div>
          </div>
        </div>
        <div className="grid">
            <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 gap-4">
                    <Bar data={dataChart} options={options} />;
            </div>
        </div>
      </div>
    </>
  );
}
